export default "__VITE_ASSET__CvS1wVnn__"